import { render, staticRenderFns } from "./banners-s-1.vue?vue&type=template&id=2d4a714b"
import script from "./banners-s-1.vue?vue&type=script&lang=js"
export * from "./banners-s-1.vue?vue&type=script&lang=js"
import style0 from "./banners-s-1.vue?vue&type=style&index=0&id=2d4a714b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports